import { BiometricIdentityVerificationRequestStatus } from "@wingspanhq/wingspan-api-sdk";

import { StepItem } from "../../../../../../shared/components/Steps";

type Props = {
  status: BiometricIdentityVerificationRequestStatus;
  isPendingSuccessStatus: boolean | undefined;
  /**
   * v1 hid the "Processed" step when the definition's review strategy was
   * approval-based; the v3 instance no longer carries the review policy, so
   * callers derive this from instance signals (pending payer review /
   * approved / rejected events).
   */
  isApprovalFlow: boolean | undefined;
};

export const getIdentityVerificationPayerProgressSteps = ({
  status,
  isPendingSuccessStatus,
  isApprovalFlow
}: Props): StepItem[] => {
  const isProcessedVisible = !isApprovalFlow;

  let steps: StepItem[];

  if (status === BiometricIdentityVerificationRequestStatus.COMPLETE) {
    steps = [
      { title: "Start", status: "Complete" },
      { title: "Processed", status: "Complete" },
      { title: "Complete", status: "Complete" }
    ];
  } else if (status === BiometricIdentityVerificationRequestStatus.FAILED) {
    steps = [
      { title: "Start", status: "Complete" },
      { title: "Processed", status: "Failed" },
      { title: "Complete", status: "Pending" }
    ];
  } else if (isPendingSuccessStatus) {
    steps = [
      { title: "Start", status: "Complete" },
      { title: "Processed", status: "Active" },
      { title: "Complete", status: "Pending" }
    ];
  } else {
    steps = [
      { title: "Start", status: "Active" },
      { title: "Processed", status: "Pending" },
      { title: "Complete", status: "Pending" }
    ];
  }

  return steps.filter(step =>
    step.title === "Processed" ? isProcessedVisible : true
  );
};
